module.exports = __webpack_public_path__ + "static/media/c2.0abc4439.jpg";